import { z } from "zod";

export const ManualJournalEntryExistsErrorSchema = z.object({
    message: z.string(),
    errorCode: z.literal(
        "manual_journal_entry_exists_in_financial_account_being_deleted",
    ),
});

export type ManualJournalEntryExistsError = z.infer<
    typeof ManualJournalEntryExistsErrorSchema
>;
